import { render, staticRenderFns } from "./DoorEditorDialog.vue?vue&type=template&id=2f6b29af"
import script from "./DoorEditorDialog.vue?vue&type=script&lang=js"
export * from "./DoorEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports